export default __webpack_public_path__ + "static/media/board.37c66a21.svg";